/**
 * Type definitions for Solana native staking operations.
 * @packageDocumentation
 */
/** Extracts network name from CAIP-2 chain ID. */
export function getSolanaNetworkName(network) {
    return network.replace("solana:", "");
}
/** Converts API network name to CAIP-2 format. */
export function toESolanaNetwork(apiNetwork) {
    switch (apiNetwork) {
        case "mainnet":
            return "solana:mainnet";
        case "testnet":
            return "solana:testnet";
        default:
            return undefined;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29sYW5hLXR5cGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL21haW4vbW9kdWxlcy9zdGFraW5nL3Byb3RvY29scy9zb2xhbmEvc29sYW5hLXR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7R0FHRztBQW9DSCxrREFBa0Q7QUFDbEQsTUFBTSxVQUFVLG9CQUFvQixDQUFDLE9BQXVCO0lBQzFELE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTLEVBQUUsRUFBRSxDQUF1QixDQUFDO0FBQzlELENBQUM7QUFFRCxrREFBa0Q7QUFDbEQsTUFBTSxVQUFVLGdCQUFnQixDQUFDLFVBQW1CO0lBQ2xELFFBQVEsVUFBVSxFQUFFLENBQUM7UUFDbkIsS0FBSyxTQUFTO1lBQ1osT0FBTyxnQkFBZ0IsQ0FBQztRQUMxQixLQUFLLFNBQVM7WUFDWixPQUFPLGdCQUFnQixDQUFDO1FBQzFCO1lBQ0UsT0FBTyxTQUFTLENBQUM7SUFDckIsQ0FBQztBQUNILENBQUMifQ==